"use strict";
import { langEn as en } from "./lang-en";
export const wordlists = {
    en: en
};
//# sourceMappingURL=wordlists.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ethersproject/wordlists/lib.esm/wordlists.js
// module id = 127
// module chunks = 0